module.exports = __webpack_public_path__ + "static/media/carinsurancepennymac.9881ea12.svg";